import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = {
  key: 0,
  class: "section"
}
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "section-content" }
const _hoisted_5 = {
  key: 1,
  class: "report-chart"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Watermark = _resolveComponent("Watermark")!
  const _component_NumberChart = _resolveComponent("NumberChart")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Watermark, { isSampleReport: _ctx.isSampleReport }, null, 8, ["isSampleReport"]),
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        (_ctx.filters.segmentData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-badge" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(this.title) + " Segmentation ", 1)
              ]),
              _createElementVNode("div", _hoisted_4, " The performance of the savers has been separated by " + _toDisplayString(this.title) + " to analyse which segments are performing better. As the data sets are invested over different time periods, we have compared the segments against the benchmark to get meaningful analysis. The scores for different segments as well as the number of savers in each segment can be seen in the graph below. A significantly underperforming data set would warrant a closer look into the constituent elements. ", 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingChartData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.chartData)
                ? (_openBlock(), _createBlock(_component_NumberChart, {
                    key: 0,
                    type: _ctx.type,
                    title: _ctx.title,
                    chartData: _ctx.chartData,
                    barColor: _ctx.barColor,
                    provider: _ctx.filters.provider,
                    isSampleReport: _ctx.isSampleReport,
                    reportfilterRanges: _ctx.reportfilterRanges
                  }, null, 8, ["type", "title", "chartData", "barColor", "provider", "isSampleReport", "reportfilterRanges"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_v_progress_circular, { indeterminate: "" })
            ])),
        _createElementVNode("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}